<template>  
  <div>
    <v-layout>
      <v-flex md8 >
        <h3>Política AIMS</h3>
			</v-flex>
    </v-layout>
    <br>
		<v-data-table
			hide-default-footer
			:headers="headers"
			:items="items"
			class="tablaT1"
			 :class="dark_t?'dark':''">
			<template v-slot:item="props">
				<tr>
					<fs1 tag='td' class="text_align_left">{{props.item.name}}</fs1>
					<fs1 tag='td'>{{props.item.due_date}}</fs1>
					<fs1 tag='td' :prop="st = due_date_status(props.item)">
						<span :class="['safety-tag', due_date_status_color[st]]">{{st}}</span>
					</fs1>
					<fs1 tag='td'>
						<a :href="props.item.link" target="_blank" v-if="props.item.link">
							<v-icon >insert_drive_file</v-icon>
						</a>
					</fs1>
				</tr>
			</template>
		</v-data-table>
  </div>	
</template>

<script>
import due_date_status from '@/components/mixins/due_date_status';

export default {
  mixins: [due_date_status],
	data() {
		return {
			items:[],
		}
	},
  computed: {
    headers() {
      return [
				{ text: 'Nombre', value: 'name' },
				{ text: 'Fecha de vencimiento', value: 'due_date', class:'width200px' },
				{ text: 'Estado', value: 'due_date', class:'width200px' },
				{ text: 'Link', value: 'link', class:'width100px' },
      ];
    },
  },
	created() {
		this.requests.gets['aims_policy/1']()		
      .then(r => this.items = [r])
	},
};
</script>
